export const mapBankTitleToImageName = (title: string) => {
  const mappings: Record<string, string> = {
    اقتصادنوین: "eqtesad-novin",
    ملت: "mellat",
    ملی: "melli",
    صادرات: "saderat",
    پارسیان: "parsian",
    پاسارگاد: "pasargad",
    تجارت: "tejarat",
    سپه: "sepah",
    سینا: "sina",
    شهر: "shahr",
    دی: "day",
    سامان: "saman",
    سرمایه: "sarmayeh",
    گردشگری: "gardeshgari",
    قوامین: "ghavamin",
    انصار: "ansar",
    "حکمت ایرانیان": "hekmat",
    "ایران زمین": "iran-zamin",
    رسالت: "resalat",
    کارآفرین: "karafarin",
    "مهر اقتصاد": "mehr-eghtesad",
    کشاورزی: "keshavarzi",
    "صنعت و معدن": "sanat-madan",
    رفاه: "refah",
    مسکن: "maskan",
    آینده: "ayandeh",
    "اقتصاد مهر ایران": "eqtesad-mehr",
    "توسعه تعاون": "taavon",
    "توسعه صادرات": "saderat-development",
    "مهر ایران": "mehr-iran",
    "پست بانک": "postbank",
    "ایران ونزوئلا": "iran-venezuela",
    خاورمیانه: "khavarmiyaneh",
  };

  return mappings[title.trim()] ?? "default";
};
